import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col py-3 my-3 space-y-4 md:space-x-4 md:space-y-0 md:flex-row" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-danger-dark material-icons-outlined" }, " close ", -1)
const _hoisted_4 = { class: "error-msg" }
const _hoisted_5 = { class: "error-msg" }
const _hoisted_6 = { class: "md:w-2/12" }
const _hoisted_7 = { class: "flex w-full items-center space-x-0.5" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "my-auto" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons" }, " delete ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_Toggle = _resolveComponent("Toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["mr-auto text-lg cursor-move md:mr-2 drag-handle material-icons-outlined opacity-70", { 'my-auto': !_ctx.singleLine, 'mt-1': _ctx.singleLine }])
      }, " drag_indicator ", 2),
      _createVNode(_component_Btn, {
        class: "ml-auto md:hidden",
        outline: true,
        variant: 'icon',
        tooltip: _ctx.$t('exercise_editor.delete_choice'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["tooltip"])
    ]),
    (!_ctx.singleLine)
      ? (_openBlock(), _createBlock(_component_TextEditor, {
          key: 0,
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur'))),
          class: "w-full md:w-10/12",
          modelValue: _ctx.modelValue.text,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdate('text', $event)))
        }, _createSlots({
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.choice_text")) + " ", 1)
          ]),
          _: 2
        }, [
          (_ctx.v$.choice.text.$errors.length > 0)
            ? {
                name: "errors",
                fn: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.choice.text.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("validation_errors.exercise.choice." + error.$uid)), 1)
                    ]))
                  }), 128))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"]))
      : (_openBlock(), _createBlock(_component_TextInput, {
          key: 1,
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur'))),
          class: "w-full md:w-10/12",
          modelValue: _ctx.modelValue.text,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.onUpdate('text', $event)))
        }, _createSlots({
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.choice_text")) + " ", 1)
          ]),
          _: 2
        }, [
          (_ctx.v$.choice.text.$errors.length > 0)
            ? {
                name: "errors",
                fn: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.choice.text.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("validation_errors.exercise.choice." + error.$uid)), 1)
                    ]))
                  }), 128))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.correctnessIsBoolean)
        ? (_openBlock(), _createBlock(_component_NumberInput, {
            key: 0,
            class: "mb-auto",
            iconFilled: true,
            max: 100,
            min: -100,
            modelValue: _ctx.modelValue.correctness,
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('blur'))),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.onUpdate('correctness', $event))),
            leftIcon: 
					_ctx.iconType === 'radio'
						? 'radio_button_checked'
						: _ctx.iconType === 'dropdown'
						? 'expand_circle_down'
						: 'check_box'
				
          }, _createSlots({
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("exercise_editor.choice_correctness")), 1)
              ])
            ]),
            _: 2
          }, [
            (_ctx.invalidCorrectness)
              ? {
                  name: "errors",
                  fn: _withCtx(() => [
                    _createTextVNode("   ")
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "leftIcon"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Toggle, {
              modelValue: _ctx.booleanCorrectnessProxy,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.booleanCorrectnessProxy) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.is_choice_correct")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Btn, {
        class: "hidden -ml-3.5 transition-opacity duration-100 opacity-50 md:mr-1 md:-ml-3 md:block hover:opacity-100",
        outline: true,
        variant: 'icon',
        tooltip: _ctx.$t('exercise_editor.delete_choice'),
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('delete')))
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["tooltip"])
    ])
  ]))
}